import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["playlistId", "language", "showNotification", "onClick", "use", "onSuccess", "render"];
import getLang from 'LearningCenterUI/utils/getLang';
import Raven from 'raven-js';
import UIButton from 'UIComponents/button/UIButton';
import UsageTracker from '../../../utils/UsageTracker';
import { usePlaylistSaveStatus } from '..';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const SavePlaylistsToggleIconMessage = ({
  isSaved
}) => isSaved ? /*#__PURE__*/_jsx(FormattedMessage, {
  message: "learningCenter.savedItems.tooltips.savedHover"
}) : /*#__PURE__*/_jsx(FormattedMessage, {
  message: "learningCenter.savedItems.tooltips.unsavedHover"
});
export const SavePlaylistButton = _ref => {
  let {
      playlistId,
      language = getLang(),
      showNotification = true,
      onClick,
      use = 'unstyled',
      onSuccess,
      render = content => /*#__PURE__*/_jsx(_Fragment, {
        children: content
      })
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    isSaved,
    isLoading,
    togglePlaylistSaveStatus
  } = usePlaylistSaveStatus(playlistId, {
    showNotification,
    language
  });
  const handleOnClick = e => {
    if (isLoading) return;
    if (onClick) onClick(e);
    const trackingAction = isSaved ? 'remove-playlist' : 'save-playlist';
    UsageTracker.track('playlistInteraction', {
      action: trackingAction,
      playlistId
    });
    togglePlaylistSaveStatus().then(onSuccess).catch(() => {
      Raven.captureMessage(`Achievements: error saving playlist`, {
        extra: {
          playlistId,
          language,
          isSaved
        }
      });
    });
  };
  return /*#__PURE__*/_jsx(UIButton, Object.assign({}, buttonProps, {
    disabled: isLoading,
    onClick: handleOnClick,
    use: use,
    children: render( /*#__PURE__*/_jsx(SavePlaylistsToggleIconMessage, {
      isSaved: isSaved
    }))
  }));
};
export default SavePlaylistButton;